import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Cosmetic Empire',
    path: '/cosmetic-empire'
  }, {
    name: 'Real Estate & Mindset',
    path: '/programme-liberty'
  }, {
    name: 'À propos',
    path: '/#about-sarah'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white border-b border-blush/40 ${isScrolled ? 'shadow-md py-3' : 'py-4'}`} data-id="element-68">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <div className="flex justify-between items-center" data-id="element-70">
          {/* Logo */}
          <Link to="/" className="flex items-center z-50 group" data-id="element-71">
            <img src="https://cdn.magicpatterns.com/uploads/s8aN1EGXj78v7vYcSAwfoK/Logo_Liberty_(1).png" alt="Sarah Liberty Program" className="h-12 md:h-14 w-auto object-contain transition-transform group-hover:scale-105" data-id="element-72" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-73">
            {navLinks.map(link => link.path.includes('#') ? <a key={link.path} href={link.path} className="text-sm font-medium transition-colors hover:text-rosegold text-navy/80" data-id="element-74">
                  {link.name}
                </a> : <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors hover:text-rosegold ${location.pathname === link.path ? 'text-rosegold' : 'text-navy/80'}`} data-id="element-75">
                  {link.name}
                </Link>)}
            <a href="https://calendly.com/sarahmarte/coaching-1-1" target="_blank" rel="noopener noreferrer" className="px-6 py-2.5 rounded-full text-sm font-medium transition-all bg-rosegold text-white shadow-lg shadow-rosegold/20 hover:bg-rosegold-dark hover:-translate-y-0.5" data-id="element-76">
              Réserver un Appel de Coaching
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden z-50 p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-77">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6 text-navy" data-id="element-78" /> : <MenuIcon className="w-6 h-6 text-navy" data-id="element-79" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-80">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="fixed inset-0 bg-blush-light z-40 flex flex-col items-center justify-center pt-20 px-4" data-id="element-81">
            <nav className="flex flex-col items-center gap-8 w-full" data-id="element-82">
              <Link to="/" className="text-2xl font-serif text-navy hover:text-rosegold transition-colors" data-id="element-83">
                Accueil
              </Link>
              {navLinks.map(link => <a key={link.path} href={link.path} onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-serif text-navy hover:text-rosegold transition-colors text-center" data-id="element-84">
                  {link.name}
                </a>)}
              <a href="https://calendly.com/sarahmarte/coaching-1-1" target="_blank" rel="noopener noreferrer" className="mt-4 w-full max-w-xs text-center bg-rosegold text-white rounded-full px-6 py-4 text-lg font-medium shadow-lg shadow-rosegold/20 hover:bg-rosegold-dark transition-colors" data-id="element-85">
                Réserver un Appel de Coaching
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}